import Vivus from "vivus";
import { setScenarizeData } from "./setScenerizeData";

type Map = {
  [key: string]: any;
};

// time to wait before showing the hidden svg and label for
// a node
const PATH_ANIMATION_INTERVAL = 350

export function onXMLImport(node: SVGElement, json: Map, cb: () => void) {
  node.classList.remove("bpmnSVG");

  node.querySelectorAll("text").forEach((node) => {
    node.style.transform = "translateY(20px)";
    node.style.opacity = "0";
  });
  node.querySelectorAll("svg").forEach((node) => {
    node.style.opacity = "0";
  });

  // hide the markers
  const markerMap: { [key: string]: string } = {};
  node.querySelectorAll(".djs-element[data-element-id]").forEach((node) => {
    const id = node.getAttribute("data-element-id");
    const path: HTMLElement | null = node.querySelector(".djs-visual path");
    if (path && id) {
      markerMap[id] = path.style.markerEnd;
      path.style.markerEnd = "";
    }
  });

  // set path elements fill value to `transparent` to improve the animation effect
  const fillMap: { [key: string]: string } = {};
  node
    .querySelectorAll(".djs-shape.djs-element[data-element-id]")
    .forEach((element) => {
      const id = element.getAttribute("data-element-id");
      const visualNode = element.querySelector(".djs-visual");

      if (visualNode && id) {
        const path: any = visualNode.querySelector(
          "path, rect, circle, ellipse, line, polyline, polygon"
        );
        if (path && path.style.fill !== "none") {
          fillMap[id] = path.style.fill;
          path.style.fill = "transparent";
          path.style.strokeWidth = "2px";
        }
      }
    });

  // prepare the SVG for proper live drawing animation effect
  const order = setScenarizeData(node, json);

  let intervalID: any = null
  new Vivus(
    node as unknown as HTMLElement,
    {
      type: "scenario",
      onReady: (vivus: any) => {
        vivus.play()
        vivus.el.classList.add("bpmnSVG");
        let i = 0;
        intervalID = setInterval(() => {
          const id = order[i]
          if(!id) {
            clearTimeout(intervalID)
            return
          }
          showSVGAndLabel(node, id, undefined)
          i++
        }, PATH_ANIMATION_INTERVAL)
      },
    },
    () => {
      showSVGAndLabel(node, order[order.length - 1], `[data-element-id="tars_bpmngenerator"]`)
      onAnimationEnd(fillMap, markerMap);
      cb();
    }
  );
}

function onAnimationEnd(fillMap: Map, markerMap: Map) {
  // show the hidden markers
  Object.entries(markerMap).forEach(([key, value]) => {
    const path: HTMLElement | null = document.querySelector(
      `.djs-element[data-element-id="${key}"] .djs-visual path`
    );
    if (path) {
      path.style.markerEnd = value;
    }
  });

  // reset the fill values to how it was before
  Object.entries(fillMap).forEach(([key, value]) => {
    const visualNode: HTMLElement | null = document.querySelector(
      `.djs-shape.djs-element[data-element-id="${key}"] .djs-visual`
    );
    if (visualNode) {
      const path: any = visualNode.querySelector(
        "path, rect, circle, ellipse, line, polyline, polygon"
      );
      if (path) {
        path.style.fill = value;
      }
    }
  });
}

// on each path animation end, show the svg and label that belongs
// to the node
function showSVGAndLabel(node: SVGElement, id: string, selector: string | undefined) {
  const sel = selector ?? `.djs-shape.djs-element[data-element-id^="${id}"]`
  const elements = node.querySelectorAll(sel)
  elements.forEach((element: any) => {
    element.querySelectorAll("text").forEach((node: any) => {
      node.style.transform = "translateY(0)";
      node.style.opacity = "1";
    });
    element.querySelectorAll("svg").forEach((node: any) => {
      node.style.opacity = "1";
    });
  })
}

export function animateNodes(node: SVGElement, id: string, ids: string[]) {
  const viNode: SVGElement | null = document.querySelector(
    `[data-element-id='${id}']`
  );
  if (viNode) {
    viNode.querySelectorAll("text").forEach((node) => {
      node.style.transform = "translateY(20px)";
      node.style.opacity = "0";
    });
    viNode.querySelectorAll("svg").forEach((node) => {
      node.style.opacity = "0";
    });

  const fillMap: { [key: string]: string } = {};
  if (viNode) {
    const path: any = viNode.querySelector(
      "path, rect, circle, ellipse, line, polyline, polygon"
    );
    if (path && path.style.fill !== "none") {
      fillMap[id] = path.style.fill;
      path.style.fill = "transparent";
      path.style.strokeWidth = "2px";
    }
  }

  if (viNode.parentElement) {
    viNode.parentElement.style.opacity = "0";
    new Vivus(
      viNode as any,
      {
        type: "sync",
        duration: 50,
        onReady: () => {
          if(viNode.parentElement) {
            viNode.parentElement.style.opacity = "1";
          }
        },
      },
      () => {
        node.classList.add("bpmnSVG");
        showSVGAndLabel(node, id, undefined)
        onAnimationEnd(fillMap, {})
        const idx = ids.findIndex(item => item === id)
        if(idx !== -1 && ids.length - 1 !== idx) {
          node.classList.remove("bpmnSVG");
          animateNodes(node, ids[idx+1], ids)
        }
      }
    );
  }
  }
}
